import { createElementBlock as e, openBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 22"
};
function r(a, l) {
  return o(), e("svg", n, [...l[0] || (l[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.401 2.75h12.197a1.25 1.25 0 0 1 1.22.979l.914 4.108.018.163a2.25 2.25 0 0 1-3.736 1.69L15 9.675l-.154.127a2.24 2.24 0 0 1-1.192.442l-.154.005c-.57 0-1.09-.212-1.486-.56L12 9.675l-.154.127a2.24 2.24 0 0 1-1.192.442l-.154.005c-.57 0-1.09-.212-1.486-.56L9 9.675l-.154.127a2.24 2.24 0 0 1-1.192.442l-.154.005c-.57 0-1.09-.212-1.486-.56L6 9.675l-.154.127a2.24 2.24 0 0 1-1.192.442l-.154.005A2.25 2.25 0 0 1 2.25 8l.018-.163.913-4.11A1.25 1.25 0 0 1 4.4 2.75m12.844 5.315-.847-3.816H4.6l-.846 3.815.003.038a.75.75 0 0 0 .641.641l.102.007A.75.75 0 0 0 5.25 8l.008-.12c.114-.878 1.492-.838 1.492.12l.007.102A.75.75 0 0 0 8.25 8l.008-.12c.114-.878 1.492-.838 1.492.12l.007.102A.75.75 0 0 0 11.25 8l.008-.12c.114-.878 1.492-.838 1.492.12l.007.102A.75.75 0 0 0 14.25 8l.008-.12c.114-.878 1.492-.838 1.492.12l.007.102A.75.75 0 0 0 17.25 8zM17.743 11.398a.75.75 0 0 0-1.493.102v6l-.007.057a.25.25 0 0 1-.243.193h-2.75V11.5l-.007-.102a.75.75 0 0 0-1.493.102v2.25h-7V11.5l-.007-.102a.75.75 0 0 0-1.493.102v6l.006.143A1.75 1.75 0 0 0 5 19.25h11l.143-.006A1.75 1.75 0 0 0 17.75 17.5v-6zM11.75 17.75v-2.5h-7v2.25a.25.25 0 0 0 .193.243L5 17.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const v = { render: r };
export {
  v as default,
  r as render
};
